var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopboxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.956843 2.78701C4.98835 -0.928297 11.5099 -0.928298 15.5414 2.78701C15.739 2.94511 15.8181 3.22178 15.8181 3.45893C15.8181 3.69607 15.739 3.93322 15.5809 4.13084C15.2252 4.48656 14.6323 4.52609 14.2371 4.17037C10.9566 1.12698 5.54169 1.12698 2.26115 4.17037C1.86591 4.52609 1.27304 4.48656 0.917318 4.13084C0.561598 3.7356 0.561598 3.14273 0.956843 2.78701ZM4.03976 7.25328C3.72356 6.85804 3.76309 6.26517 4.11881 5.90945C6.3717 3.93322 10.0475 3.93322 12.3004 5.90945C12.5375 6.10707 12.6561 6.38374 12.6561 6.62089C12.6561 6.85804 12.5375 7.09518 12.419 7.25328C12.0632 7.64853 11.4704 7.68805 11.0751 7.33233C9.49414 5.94897 6.92505 5.94897 5.34407 7.33233C4.98835 7.68805 4.35595 7.64853 4.03976 7.25328Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81797 11.8811C2.81797 11.2524 3.3276 10.7428 3.95627 10.7428H12.0509C12.6796 10.7428 13.1892 11.2524 13.1892 11.8811V19.9757C13.1892 20.6044 12.6796 21.114 12.0509 21.114H3.95627C3.3276 21.114 2.81797 20.6044 2.81797 19.9757V11.8811Z",
    stroke: "#00263A",
    strokeWidth: 1.7707,
    fill: "transparent",
    id: "topboxes"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopboxes);
export default __webpack_public_path__ + "static/media/topboxes.18499e447b5e547ad3d1af75e62b0fa7.svg";
export { ForwardRef as ReactComponent };